import { render, staticRenderFns } from "./settingsBankAccounts.vue?vue&type=template&id=4fece490&scoped=true&"
import script from "./settingsBankAccounts.vue?vue&type=script&lang=js&"
export * from "./settingsBankAccounts.vue?vue&type=script&lang=js&"
import style0 from "./settingsBankAccounts.vue?vue&type=style&index=0&id=4fece490&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fece490",
  null
  
)

export default component.exports